<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <permission-btn moduleName='Tx_CompareForms' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item txCompareforms">
      <div class="bg-white fh" id='txCompareForms-table'>
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else-if="item.key === 'compareNo'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'txCompareForms')">{{ scope.row.compareNo }}</a>
                </span>
              <span v-else-if="item.key === 'quotCode'">
                  <a class="link-type" @click.stop="openDrawer(scope.row,'txQuots')">{{ scope.row.quotCode }}</a>
                </span>
              <span v-else-if="item.key === 'purchasePlanCode'">
                  <a class="link-type"
                     @click.stop="openDrawer(scope.row,'txOrderPlanDetails')">{{ scope.row.purchasePlanCode }}</a>
                </span>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{
                    scope.row[item.key] | dateFormat
                  }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
      <add-instance ref="dataForm" :sourceCode="crmType"
                    createdFormId="txCompareForms-dialog"
                    :visible.sync="dialogFormVisible"
                    :initData="initData">
      </add-instance>

      <edit-instance ref="editForm" :sourceCode="crmType"
                     createdFormId="txCompareForms-dialog"
                     :visible.sync="dialogEditVisible"
                     :initData="temp" :solt-name-array="soltNameArray">
        <template slot="orderDetail">
          <el-table
            ref="PlanDetailTable"
            :data="temp.orderDetail"
            height="60vh"
            border fit highlight-current-row
            style="width: 100%">
            <el-table-column fixed type="selection" align="center" width="55"></el-table-column>
            <el-table-column
              fixed
              prop="backPlan"
              label="退回采购计划"
              min-width="80">
              <template slot-scope="scope">
                <el-select v-model="scope.row.backPlan">
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="accName"
              label="采购方"
              min-width="100">
            </el-table-column>
            <el-table-column
              fixed
              prop="cInvName"
              label="存货名称"
              min-width="100">
            </el-table-column>
            <el-table-column
              fixed
              prop="cInvStd"
              label="规格型号"
              min-width="80">
            </el-table-column>
            <el-table-column
              fixed
              prop="invConfirmCount"
              label="数量"
              min-width="70">
            </el-table-column>
            <el-table-column
              fixed
              prop="cComUnitName"
              label="单位"
              min-width="70">
            </el-table-column>
            <el-table-column
              fixed
              prop="needDate"
              label="需求日期"
              min-width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.needDate | dateFormat }}</span>
              </template>
            </el-table-column>
            <el-table-column
              fixed
              prop="remarks"
              label="采购备注"
              min-width="100">
            </el-table-column>
            <el-table-column v-for="(item,index) in lstSupply" :key="index" :label="item.venName">
              <el-table-column label="最终单价" min-width="100">
                <template slot-scope="scope">
                      <span v-if="scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?0: scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).bidCount>0"
                            style="color:red;font-size: 15px ">
                        {{ scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).finalPrice }}
                      </span>
                  <span v-else>
                        {{scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?0: scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).finalPrice }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column min-width="200px"
                               label="中标数量">
                <template slot-scope="scope">
                  <el-input-number size="small" style="width:100%" controls-position="right"
                                   :value="(scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?0:scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).bidCount)?scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).bidCount:0"
                                   @change="(val)=>{bidCountinput(scope,item.id,val,'bidCount')}"></el-input-number>
                </template>
              </el-table-column>
              <el-table-column                label="税率" min-width="100">
                <template slot-scope="scope" >
                      <span>
                        {{scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'': scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).invTaxRate }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column
                label="最终单价"  min-width="100">
                <template slot-scope="scope">
                      <span>
                        {{scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'':  scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).finalPrice }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column                label="最终总价"  min-width="100">
                <template slot-scope="scope">
                      <span>
                        {{ scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'': scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).finalTotalPrice }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column label="首次单价" min-width="100">
                <template slot-scope="scope">
                      <span>
                        {{ scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'': scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).price }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column label="首次总价" min-width="100">
                <template slot-scope="scope">
                      <span>
                        {{ scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'': scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).totalPrice }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column label="付款方式" min-width="100">
                <template slot-scope="scope">
                      <span>
                        {{scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'':  scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).payType }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column label="二次单价" min-width="100">
                <template slot-scope="scope">
                    <span>
                        {{
                        ( scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'':   scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).priceSecond) ? scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).priceSecond : 0
                      }}
                      </span>
                  <!--                  <el-input-number size="small" style="width:100%" controls-position="right" disabled-->
                  <!--                                   :value="scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).priceSecond?scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).priceSecond:0"-->
                  <!--                                   @change="(val)=>{bidCountinput(scope,item.id,val,'priceSecond')}"></el-input-number>-->
                </template>
              </el-table-column>
              <el-table-column label="二次总价" min-width="100">
                <template slot-scope="scope">
                   <span>
                        {{
                       (scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'':  scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).totalPriceSecond )? scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).totalPriceSecond : 0
                     }}
                      </span>
                  <!--                  <el-input-number size="small" style="width:100%" controls-position="right" disabled-->
                  <!--                                   :value="scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).totalPriceSecond?scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).totalPriceSecond:0"-->
                  <!--                                   @change="(val)=>{bidCountinput(scope,item.id,val,'totalPriceSecond')}"></el-input-number>-->
                </template>
              </el-table-column>
              <el-table-column label="议价备注" min-width="200">
                <template slot-scope="scope">
                   <span>
                        {{scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'':  scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).secondRemarks }}
                      </span>
                  <!--                  <el-input size="small" style="width:100%"-->
                  <!--                            :value="scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).secondRemarks?scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).secondRemarks:''"-->
                  <!--                            @input="(val)=>{bidCountinput(scope,item.id,val,'secondRemarks')}"></el-input>-->
                </template>
              </el-table-column>
              <el-table-column label="交货期" min-width="100">
                <template slot-scope="scope">
                      <span>
                        {{scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'':  scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).dtOfDelivery }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column label="备注" min-width="100">
                <template slot-scope="scope">
                      <span>
                        {{scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'':  scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).remarks }}
                      </span>
                </template>
              </el-table-column>
              <el-table-column label="附件" min-width="100">
                <template slot-scope="scope">
                  <FormUpload
                    :value="scope.row.venPriceDetail.find(u => u.supplyGuid === item.id)===undefined?'': scope.row.venPriceDetail.find(u => u.supplyGuid === item.id).attr"
                    :disabled="true"
                    :width="50"
                    :height="50"
                  >
                  </FormUpload>
                </template>
              </el-table-column>
            </el-table-column>

          </el-table>
        </template>
      </edit-instance>

      <edit-instance ref="editSecondForm" :sourceCode="'Tx_SecondaryQuotes'"
                     createdFormId="txCompareForms-dialog"
                     :visible.sync="dialogSecondEditVisible"
                     :initData="secondtemp" :solt-name-array="soltNameSecondArray">
        <template slot="secondVenGuid">
          <el-input :value="secondtemp.secondVenName" readonly>
            <!--                切换的那个按钮-->
            <el-button slot="append" icon="el-icon-search" @click="()=>{dialogAccessVisible=true}"></el-button>
          </el-input>
        </template>
      </edit-instance>

      <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
                   :dialog-visible.sync="dialogQueryVisible"/>

      <my-transfer :code="crmType" @filter="handleFilter"
                   :titles="['待配置列', '显示列']"
                   :dialog-visible.sync="dialogSetVisible"/>

      <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype"
                   :menukeyArray="menukeyArray"></drawerViews>

      <el-dialog class="dialog-mini" top="15vh" v-el-drag-dialog :title="'选择供应商'"
                 :visible.sync="dialogAccessVisible">
        <SelectSupplyInfo ref="SelectSupplyInfo" v-if="dialogAccessVisible" :accGuid="accGuid" :venids="venids"
                          @close="dialogAccessVisible=false" @closeMoule="closeMoule"/>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import * as txCompareForms from '@/api/tx_compareforms';
import * as txQuots from '@/api/tx_quots';
import mytable from '@/utils/crmtableFlowV2';
import SelectSupplyInfo from '@/components/SelectSupplyInfo';
import * as txPurchasePlans from '@/api/tx_purchaseplans';
import FormUpload from '@/components/Formcreated/components/FormImageUpload';
import unfixed from '@/components/cron/config/custom/unfixed.vue';

export default {
  name: 'txCompareForms',
  computed: {
    unfixed() {
      return unfixed;
    }
  },
  components: { SelectSupplyInfo, FormUpload },
  mixins: [mytable],
  data() {
    return {
      crmType: 'Tx_CompareForm',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {},
      soltNameArray: ['orderDetail'],
      soltNameSecondArray: ['secondVenGuid'],
      lstSupply: [],
      dialogSecondEditVisible: false,
      secondtemp: {},
      dialogAccessVisible: false,
      accGuid: '',
      venids: ''
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      if (!this.dialogSecondEditVisible) {
        return txCompareForms;
      } else {
        return {
          update: (data) => {
            return this.saveSecondtemp(data);
          }
        };
      }
    },
    btnClickOther(bomid) {
      switch (bomid) {
        case 'btnCompareForm':
          txCompareForms.AsyncCompareForm().then(res => {
            this.$message({
              message: '更新状态成功',
              type: 'success'
            });
            this.getList();
          });
          break;
        case 'btnTow':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Tow();
            // this.$confirm('是否要进行二次报价?', '提示', {
            //   confirmButtonText: '确定',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // }).then(() => {
            //   this.multipleSelection[0].id
            //   txCompareForms.BeginSecondPrice(this.multipleSelection[0].id).then(res => {
            //     this.$message({
            //       message: '二次报价成功',
            //       type: 'success'
            //     })
            //     this.getList()
            //   }).catch((_) => {
            //   })
            // }).catch(() => {
            //
            // })
          }
          break;
        case 'btnTowOver':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.TowOver();
          }
          break;
        case 'btnparamStr':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.btnparamStr();
          }
          break;
        case 'btnAudit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条记录',
              type: 'error'
            });
            return;
          } else {
            this.Audit();
          }
          break;
        case 'btnDels':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '请选择一条数据',
              type: 'error'
            });
            return;
          } else {
            this.Dels();
          }
          break;
      }
    },
    Dels() {
      this.$confirm('是否要删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const paramStr = {
          keyValue: this.multipleSelection.map(item => item.id).join(',')
        };
        txCompareForms.dels(paramStr).then(res => {
          this.$message({
            message: '删除成功',
            type: 'success'
          });
          this.getList();
        }).catch((_) => {
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    btnparamStr() {
      this.$confirm('是否提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const conforms = this.multipleSelection.filter(u => u.state === '已处理');
        const paramStr = JSON.stringify({
          // 先找到被选择的数据
          // 找到被选择数据的id,转成字符串格式
          keyValue: conforms.map(u => u.id).join(','),
          AccountId: this.getAccountId()
        });
        this.listLoading = true;
        if (conforms && conforms.length > 0) {
          txCompareForms.Commit(paramStr).then(res => {
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            this.getList();
          });
        } else {
          this.$message({
            message: '请选择已处理的比价单！',
            type: 'error'
          });
          this.getList();
        }
      }).catch(() => {
      });
    },
    Audit() {
      this.$confirm('是否审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.multipleSelection[0].id;
        txCompareForms.Approve(this.multipleSelection[0].id).then(res => {
          this.$message({
            message: '审核成功',
            type: 'success'
          });
          this.getList();
        }).catch((_) => {
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    TowOver() {
      this.$confirm('是否要结束二次报价?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.multipleSelection[0].id;
        txCompareForms.FinishSecondPrice(this.multipleSelection[0].id).then(res => {
          this.$message({
            message: '结束二次报价',
            type: 'success'
          });
          this.getList();
        }).catch((_) => {
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    Tow() {
      const paramStr = JSON.stringify({
        keyValue: this.multipleSelection[0].quotGuid,
        fromPlan: 0
      });
      txQuots.get(paramStr).then(response => {
        this.secondtemp = response.result == null ? {} : response.result;
        this.accGuid = this.secondtemp.orderDetail.map(u => u.accountId).join(',');
        this.venids = this.secondtemp.venGuid;
        this.secondtemp.secondVenGuid = this.secondtemp.venGuid;
        this.secondtemp.secondVenName = this.secondtemp.venName;
        this.secondtemp.compareid = this.multipleSelection[0].id;
        this.dialogStatus = 'update';
        this.dialogSecondEditVisible = true;
      });
    },

    saveSecondtemp(data) {
      return txCompareForms.BeginSecondPrice({
        id: data.compareid,
        attr: data.attr,
        secondVenGuid: data.secondVenGuid,
        secondVenName: data.secondVenName,
        quotGuid: data.id
      });
    },
    bidCountinput(scope, supplyGuid, val, key) {
      scope.row.venPriceDetail.find(u => u.supplyGuid === supplyGuid)[key] = val;
    },
    handleUpdate(row) { // 弹出编辑框
      this.lstSupply = [];
      this.getApi().get(row.id).then(response => {
        this.temp = response.result == null ? { orderDetail: [] } : response.result;
        this.lstSupply = response.otherData.map(u => ({ ...u }));
        this.dialogStatus = 'update';
        this.dialogEditVisible = true;
      });
    },
    closeMoule(e) {
      this.$refs.editSecondForm.$refs.frmEditData.AssignmentModel('secondVenGuid', e.map(u => u.id).join(','));
      this.$refs.editSecondForm.$refs.frmEditData.AssignmentModel('secondVenName', e.map(u => u.venName).join(','));
      this.secondtemp.secondVenName = e.map(u => u.venName).join(',');
      this.dialogAccessVisible = false;
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'txCompareForms') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'tx_compareformsview' }
        ]; // 要显示的标签
        this.drawer = true;
      } else if (type === 'txQuots') {
        const paramStr = JSON.stringify({
          keyValue: row.quotGuid,
          fromPlan: 0
        });
        txQuots.get(paramStr).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_quotsview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      } else if (type === 'txPurchasePlans') {
        txPurchasePlans.get(row.purchasePlanCode).then(res => {
          this.drawertemp = { ...this.drawertemp, ...res.result };
          this.menukeyArray = [
            { name: '', menukey: 'tx_purchaseplansview' }
          ]; // 要显示的标签
          this.drawer = true;
        });
      }
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}

/* 防止样式污染，使用id为每个页面定义表格体高度 */
#txCompareForms-table .el-table__body-wrapper {
  height: calc(100% - 57px) !important;
}

.txCompareforms .edit_dialog {
  height: calc(100vh - 106px) !important;
  box-sizing: border-box;
}

.txCompareforms .el-dialog {
  margin: 0 !important;
  box-sizing: border-box;
  width: 100% !important;

}
</style>
